import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import { useConstants } from "../hooks/UseConstants";
import AppSidebarShell from "./layout/AppSidebarShell";

function Sidebar() {
    const { language } = useConstants();
    const { wait, user } = useContext(AuthContext);
    const navigate = useNavigate();
    const isAr = language === 'ar';

    const goLogin = (from) => navigate('/login', { state: { from } });

    const learningItems = [
        { title: isAr ? 'الرئيسية' : 'Home', icon: HomeOutlinedIcon, link: '/home', end: true },
        { title: isAr ? 'الدورات' : 'Courses', icon: MenuBookOutlinedIcon, link: '/courses' },
        { title: isAr ? 'المسارات' : 'Paths', icon: AccountTreeOutlinedIcon, link: '/paths' },
    ];

    if (user) {
        learningItems.splice(2, 0, {
            title: isAr ? 'دوراتي' : 'My Courses',
            icon: SchoolOutlinedIcon,
            link: '/my-courses',
        });
    }

    const sections = [
        {
            label: isAr ? 'التعلم' : 'Learning',
            items: learningItems,
        },
    ];

    if (user) {
        sections.push({
            label: isAr ? 'حسابي' : 'My Account',
            items: [
                { title: isAr ? 'المحفظة' : 'Wallet', icon: AccountBalanceWalletOutlinedIcon, link: '/wallet' },
                { title: isAr ? 'الشهادات والتحقق' : 'Certificates', icon: WorkspacePremiumOutlinedIcon, link: '/certificates' },
                { title: isAr ? 'الإشعارات' : 'Notifications', icon: NotificationsNoneOutlinedIcon, link: '/notifications' },
            ],
        });
    } else {
        sections.push({
            label: isAr ? 'الحساب' : 'Account',
            items: [
                {
                    title: isAr ? 'تسجيل الدخول' : 'Login',
                    icon: LoginOutlinedIcon,
                    link: '/login',
                    onClick: () => goLogin('/home'),
                },
            ],
        });
    }

    return <AppSidebarShell sections={sections} homeLink="/home" show={!wait} />;
}

export default Sidebar;
